export const ACTIVE_PILL =
  "border border-lime-600/20 bg-lime-600/10 text-lime-900";

export const NEUTRAL_PILL =
  "border border-border/60 bg-muted/30 text-muted-foreground";

export const DESTRUCTIVE_PILL =
  "border border-destructive/40 bg-destructive/10 text-destructive";

export const WARNING_PILL =
  "border border-amber-600/30 bg-amber-500/10 text-amber-900";
